const middleware = {}

middleware['globalMiddleware'] = require('../../src/middleware/globalMiddleware.js')
middleware['globalMiddleware'] = middleware['globalMiddleware'].default || middleware['globalMiddleware']

export default middleware
